//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.adapter

import blazern.lexisoup.graphql.model.LexicalItemsFromPanLexQuery
import blazern.lexisoup.graphql.model.fragment.TranslationsSetFieldsImpl_ResponseAdapter
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.evaluate
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import com.apollographql.apollo.api.possibleTypes
import kotlin.String
import kotlin.collections.List

public object LexicalItemsFromPanLexQuery_ResponseAdapter {
  public object Data : Adapter<LexicalItemsFromPanLexQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("panlex")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromPanLexQuery.Data {
      var _panlex: List<LexicalItemsFromPanLexQuery.Panlex>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _panlex = Panlex.obj(true).list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LexicalItemsFromPanLexQuery.Data(
        panlex = _panlex ?: missingField(reader, "panlex")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromPanLexQuery.Data,
    ) {
      writer.name("panlex")
      Panlex.obj(true).list().toJson(writer, customScalarAdapters, value.panlex)
    }
  }

  public object Panlex : Adapter<LexicalItemsFromPanLexQuery.Panlex> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromPanLexQuery.Panlex {
      var __typename: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      check(__typename != null) {
        "__typename was not found"
      }

      var _onWordTranslations: LexicalItemsFromPanLexQuery.OnWordTranslations? = null
      if (possibleTypes("WordTranslations").evaluate(customScalarAdapters.falseVariables, __typename, customScalarAdapters.deferredFragmentIdentifiers, null)) {
        reader.rewind()
        _onWordTranslations = blazern.lexisoup.graphql.model.adapter.LexicalItemsFromPanLexQuery_ResponseAdapter.OnWordTranslations.fromJson(reader, customScalarAdapters)
      }

      var _onSynonyms: LexicalItemsFromPanLexQuery.OnSynonyms? = null
      if (possibleTypes("Synonyms").evaluate(customScalarAdapters.falseVariables, __typename, customScalarAdapters.deferredFragmentIdentifiers, null)) {
        reader.rewind()
        _onSynonyms = blazern.lexisoup.graphql.model.adapter.LexicalItemsFromPanLexQuery_ResponseAdapter.OnSynonyms.fromJson(reader, customScalarAdapters)
      }

      return LexicalItemsFromPanLexQuery.Panlex(
        __typename = __typename,
        onWordTranslations = _onWordTranslations,
        onSynonyms = _onSynonyms
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromPanLexQuery.Panlex,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      if (value.onWordTranslations != null) {
        OnWordTranslations.toJson(writer, customScalarAdapters, value.onWordTranslations)
      }

      if (value.onSynonyms != null) {
        OnSynonyms.toJson(writer, customScalarAdapters, value.onSynonyms)
      }
    }
  }

  public object OnWordTranslations : Adapter<LexicalItemsFromPanLexQuery.OnWordTranslations> {
    public val RESPONSE_NAMES: List<String> = listOf("source", "translationsSet")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromPanLexQuery.OnWordTranslations {
      var _source: String? = null
      var _translationsSet: LexicalItemsFromPanLexQuery.TranslationsSet? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _translationsSet = TranslationsSet.obj(true).fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LexicalItemsFromPanLexQuery.OnWordTranslations(
        source = _source ?: missingField(reader, "source"),
        translationsSet = _translationsSet ?: missingField(reader, "translationsSet")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromPanLexQuery.OnWordTranslations,
    ) {
      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)

      writer.name("translationsSet")
      TranslationsSet.obj(true).toJson(writer, customScalarAdapters, value.translationsSet)
    }
  }

  public object TranslationsSet : Adapter<LexicalItemsFromPanLexQuery.TranslationsSet> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromPanLexQuery.TranslationsSet {
      var __typename: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      reader.rewind()
      val _translationsSetFields = blazern.lexisoup.graphql.model.fragment.TranslationsSetFieldsImpl_ResponseAdapter.TranslationsSetFields.fromJson(reader, customScalarAdapters)

      return LexicalItemsFromPanLexQuery.TranslationsSet(
        __typename = __typename ?: missingField(reader, "__typename"),
        translationsSetFields = _translationsSetFields
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromPanLexQuery.TranslationsSet,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      TranslationsSetFieldsImpl_ResponseAdapter.TranslationsSetFields.toJson(writer, customScalarAdapters, value.translationsSetFields)
    }
  }

  public object OnSynonyms : Adapter<LexicalItemsFromPanLexQuery.OnSynonyms> {
    public val RESPONSE_NAMES: List<String> = listOf("source", "translationsSet")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromPanLexQuery.OnSynonyms {
      var _source: String? = null
      var _translationsSet: LexicalItemsFromPanLexQuery.TranslationsSet1? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _translationsSet = TranslationsSet1.obj(true).fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LexicalItemsFromPanLexQuery.OnSynonyms(
        source = _source ?: missingField(reader, "source"),
        translationsSet = _translationsSet ?: missingField(reader, "translationsSet")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromPanLexQuery.OnSynonyms,
    ) {
      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)

      writer.name("translationsSet")
      TranslationsSet1.obj(true).toJson(writer, customScalarAdapters, value.translationsSet)
    }
  }

  public object TranslationsSet1 : Adapter<LexicalItemsFromPanLexQuery.TranslationsSet1> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromPanLexQuery.TranslationsSet1 {
      var __typename: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      reader.rewind()
      val _translationsSetFields = blazern.lexisoup.graphql.model.fragment.TranslationsSetFieldsImpl_ResponseAdapter.TranslationsSetFields.fromJson(reader, customScalarAdapters)

      return LexicalItemsFromPanLexQuery.TranslationsSet1(
        __typename = __typename ?: missingField(reader, "__typename"),
        translationsSetFields = _translationsSetFields
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromPanLexQuery.TranslationsSet1,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      TranslationsSetFieldsImpl_ResponseAdapter.TranslationsSetFields.toJson(writer, customScalarAdapters, value.translationsSetFields)
    }
  }
}
